import React from 'react';

import './DraftPanoramaPortal.scss';

export const DraftPanoramaPortalId = 'draft-panorama-portal';

// Component to which Draft Panorama will be rendered see https://reactjs.org/docs/portals.html
export const DraftPanoramaPortal: React.FC = () => <div id={DraftPanoramaPortalId} className="draft-panorama-portal" />;
